document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.faqs-item .card-header').forEach(header => {

    header.addEventListener('click', function () {
      const collapse = this.nextElementSibling;

      // Toggle collapsed class
      this.classList.toggle('collapsed');

      // Toggle height animation
      if (collapse.style.maxHeight) {
        collapse.style.maxHeight = null;
        collapse.classList.remove('open');
      } else {
        collapse.style.maxHeight = collapse.scrollHeight + "px";
        collapse.classList.add('open');
      }
    });

  });
});

// Fix: Allow main collection links (Women, Men, Kids) to navigate in mobile menu
// Uses capture phase to fire BEFORE the theme's body handler that blocks navigation
document.addEventListener('click', function(e) {
  var link = e.target.closest('.site-nav-mobile .menu_mobile_link > a');
    if (link && link.getAttribute('href') && link.getAttribute('href') !== '#') {
        e.stopPropagation();
            window.location.href = link.getAttribute('href');
              }
                // LEVEL 2: Handbags, Clothing, Footwear etc. — the <a> IS the menu_mobile_link
  // The arrow span has pointer-events:none so clicks ALWAYS land on the <a> element
  // Use click X position: right 55px = arrow zone (open submenu), left = navigate
  var level2Link = e.target.closest('a.menu_mobile_link[href]');
  if (level2Link && level2Link.getAttribute('href') && level2Link.getAttribute('href') !== '#') {
    var rect = level2Link.getBoundingClientRect();
    if (e.clientX <= rect.right - 55) {
      e.stopPropagation();
      window.location.href = level2Link.getAttribute('href');
    }
  }
}, true);